// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Sticky } from "../../../components/sticky/Sticky";
import { Observer } from "mobx-vue";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Sticky,
  },
})
export class BreadcrumbModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  get breadcrumbTheme() {
    return this.backgroundColor == "white" ? "default" : "secondary";
  }

  get isSticky() {
    return this.instance["is_sticky"];
  }

  get hasTopLink() {
    return this.instance["has_top_link"];
  }
}
